import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

import UserList from "../pages/Masters/Users/userList";
import UserCreate from "../pages/Masters/Users/UserCreate";
import UserView from "../pages/Masters/Users/UserView";

import RoleView from "../pages/Masters/Role/RoleView";
import RoleList from "../pages/Masters/Role/RoleList";
import RoleCreate from "../pages/Masters/Role/RoleCreate";
import MenuList from "../pages/Masters/Menu/MenuList";
import MenuCreate from "../pages/Masters/Menu/MenuCreate";
import MenuView from "../pages/Masters/Menu/MenuView";
import MenusOptionsList from "../pages/Access/MenuAccess/MenusOptionList";
import MenuAccessMaster from "../pages/Access/MenuAccess/MenuAccessMaster";
import UserMenuAccess from "../pages/Access/UserMenuAccess/UserMenuAccess";
import CountryView from "../pages/Masters/Country/CountryView";
import CountryList from "../pages/Masters/Country/CountryList";
import CountryCreate from "../pages/Masters/Country/CountryCreate";
import StateView from "../pages/Masters/State/StateView";
import StateList from "../pages/Masters/State/StateList";
import StateCreate from "../pages/Masters/State/StateCreate";
import CityView from "../pages/Masters/City/CityView";
import CityList from "../pages/Masters/City/CityList";
import CityCreate from "../pages/Masters/City/CityCreate";
import UOMView from "../pages/Masters/UOM/UOMView";
import UOMList from "../pages/Masters/UOM/UOMList";
import UOMCreate from "../pages/Masters/UOM/UOMCreate";
import CategoryView from "../pages/Masters/Category/CategoryView";
import CategoryList from "../pages/Masters/Category/CategoryList";
import CategoryCreate from "../pages/Masters/Category/CategoryCreate";
import MaterialView from "../pages/Masters/Material/MaterialView";
import MaterialList from "../pages/Masters/Material/MaterialList";
import MaterialCreate from "../pages/Masters/Material/MaterialCreate";
import BranchView from "../pages/Masters/Branch/BranchView";
import BranchList from "../pages/Masters/Branch/BranchList";
import BranchCreate from "../pages/Masters/Branch/BranchCreate";
import ScrapReasonView from "../pages/Masters/ScrapReason/ScrapReasonView";
import ScrapReasonList from "../pages/Masters/ScrapReason/ScrapReasonList";
import ScrapReasonCreate from "../pages/Masters/ScrapReason/ScrapReasonCreate";
import MaterialIntakeView from "../pages/Masters/MaterialIntakes/MaterialIntakeView";
import MaterialIntakeList from "../pages/Masters/MaterialIntakes/MaterialIntakeList";
import MaterialIntakeCreate from "../pages/Masters/MaterialIntakes/MaterialIntakeCreate";
import MaterialApproval from "../pages/MaterialApproval/MaterialApproval";
import SparePartRequestView from "../pages/SparePartRequests/SparePartRequestView";
import SparePartRequestList from "../pages/SparePartRequests/SparePartRequestList";
import SparePartRequestCreate from "../pages/SparePartRequests/SparePartRequestCreate";
import SparePartIssues from "../pages/SparePartIssues/SparePartIssuesCreate";
import SparePartIssuesCreate from "../pages/SparePartIssues/SparePartIssuesCreate";
import SparePartIssuesList from "../pages/SparePartIssues/SparePartIssuesList";
import SparePartIssuesView from "../pages/SparePartIssues/SparePartIssuesView";
import JobCardView from "../pages/JobCard/JobCardView";
import JobCardList from "../pages/JobCard/JobCardList";
import JobCardCreate from "../pages/JobCard/JobCardCreate";
import ScrapView from "../pages/Scrap/ScrapView";
import ScrapList from "../pages/Scrap/ScrapList";
import ScrapCreate from "../pages/Scrap/ScrapCreate";

const createRoute = (path, component) => ({ path, component });

const routes = [
  createRoute("/dashboard", <Dashboard />),

  createRoute("/user-list", <UserList />),
  createRoute("/user-create/:id?", <UserCreate />),
  createRoute("/user-view/:id?", <UserView />),

  createRoute("/role-view/:id?", <RoleView />),
  createRoute("/role-list", <RoleList />),
  createRoute("/role-create/:id?", <RoleCreate />),

  createRoute("/menu-list", <MenuList />),
  createRoute("/menu-create/:id?", <MenuCreate />),
  createRoute("/menu-view/:id?", <MenuView />),

  //country
  createRoute("/country-view/:id?", <CountryView />),
  createRoute("/country-list", <CountryList />),
  createRoute("/country-create/:id?", <CountryCreate />),

  //state
  createRoute("/state-view/:id?", <StateView />),
  createRoute("/state-list", <StateList />),
  createRoute("/state-create/:id?", <StateCreate />),

  //city
  createRoute("/city-view/:id?", <CityView />),
  createRoute("/city-list", <CityList />),
  createRoute("/city-create/:id?", <CityCreate />),

  //UOM
  createRoute("/uom-view/:id?", <UOMView />),
  createRoute("/uom-list", <UOMList />),
  createRoute("/uom-create/:id?", <UOMCreate />),

  //Category
  createRoute("/category-view/:id?", <CategoryView />),
  createRoute("/category-list", <CategoryList />),
  createRoute("/category-create/:id?", <CategoryCreate />),

  //Material
  createRoute("/material-view/:id?", <MaterialView />),
  createRoute("/material-list", <MaterialList />),
  createRoute("/material-create/:id?", <MaterialCreate />),

  //Branch
  createRoute("/branch-view/:id?", <BranchView />),
  createRoute("/branch-list", <BranchList />),
  createRoute("/branch-create/:id?", <BranchCreate />),

  //Scrap Reason
  createRoute("/scrap-reason-view/:id?", <ScrapReasonView />),
  createRoute("/scrap-reason-list", <ScrapReasonList />),
  createRoute("/scrap-reason-create/:id?", <ScrapReasonCreate />),

  //Menu Access
  createRoute("/menu-access-view/:id?", <MaterialView />),
  createRoute("/menu-access-list", <MenuAccessMaster />),
  createRoute("/menu-access-create/:id?", <MaterialCreate />),

  //Material Intakes
  createRoute("/material-intakes-view/:id?", <MaterialIntakeView />),
  createRoute("/material-intakes-list", <MaterialIntakeList />),
  createRoute("/material-intakes-create/:id?", <MaterialIntakeCreate />),

  createRoute("/material-approval", <MaterialApproval />),

  createRoute("/user-access-list", <UserMenuAccess />),

  //job card
  createRoute("/job-card-list", <JobCardList />),
  createRoute("/job-card-view/:id?", <JobCardView />),
  createRoute("/job-card-create/:id?", <JobCardCreate />),
  //Spare Part Requests
  createRoute("/spare-part-requests-view/:id?", <SparePartRequestView />),
  createRoute("/spare-part-requests-list", <SparePartRequestList />),
  createRoute("/spare-part-requests-create/:id?", <SparePartRequestCreate />),

  //Spare Part Issues
  createRoute("/spare-part-issues-view/:id?", <SparePartIssuesView />),
  createRoute("/spare-part-issues-list", <SparePartIssuesList />),
  createRoute("/spare-part-issues-create/:id?", <SparePartIssuesCreate />),
  //Scrap
  createRoute("/scrap-view/:id?", <ScrapView />),
  createRoute("/scrap-list", <ScrapList />),
  createRoute("/scrap-create/:id?", <ScrapCreate />),

  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const paginationRoute = routes
  .filter((route) => ["/user-list"].includes(route.path))
  .map((route) => route.path);

export { routes, paginationRoute };
